import { L3_PATHS } from 'Deer/constants/routes';
import { staticRoutesWithCustomSidebar } from 'Deer/constants/staticRoutesWithCustomSidebar';

import {
  DISCIPLINARY_ACTIONS_INTENT_ID_MAP,
  ENGAGEMENT_INTENTS,
  GOAL_INTENTS,
  ONE_ON_ONE_INTENTS,
  POINTS_INTENTS,
  REVIEW_INTENTS,
} from './moduleIntentTypes';

export const netchexRoutes = {
  dashboard: '/n/Dashboard#/',
};

export const NETCHEX_ROLE = {
  EMPLOYEE: 'employee',
  MANAGER: 'manager',
  ADMIN: 'admin',
};

export const NETCHEX_GLOBAL_NAV_ID = 'global-nav';

export const isNetchexLogin = process.env.PUBLIC_NETCHEX_LOGIN_FLOW === 'true';

// this is same for old and new
export const NETCHEX_SIDEPANEL_WIDTH = '250px';

export const NETCHEX_NEW_ICON_ONLY_SIDEPANEL_WIDTH = '50px';

export const NETCHEX_NEW_NAV_BODY_CLASS = 'site-nav-left-layout';
export const NETCHEX_NEW_NAV_COLLAPSED_BODY_CLASS = 'site-nav-left-layout-collapsed';

export const EMPLOYEE_VIEW_MODULE_INTENTS_MAP = {
  goal: [
    {
      key: GOAL_INTENTS.MANAGE_GOALS,
      label: 'My goals',
      path: '/app/my-data/goal/my-goals/',
      isMobileSupport: true,
    },
    {
      key: GOAL_INTENTS.COMPANY_GOALS,
      label: 'Company goals',
      path: '/app/my-data/goal/my-company/',
      isMobileSupport: false,
    },
    {
      key: GOAL_INTENTS.UPLOAD_GOALS,
      label: 'Import goals',
      path: '/app/my-data/goal/upload/',
      isMobileSupport: false,
    },
    {
      key: GOAL_INTENTS.CHECK_IN_GOALS,
      label: 'Check-in to multiple goals',
      path: '/app/my-data/goal/check-in/',
      isMobileSupport: false,
    },
  ],

  // develop: [
  //   {
  //     key: FEEDBACK_INTENTS.COMPETENCIES,
  //     label: 'Competencies',
  //     path: '/app/my-data/develop/competencies/',
  //   },
  //   {
  //     key: FEEDBACK_INTENTS.COMPANY_PRAISES,
  //     label: 'Company praises',
  //     path: '/app/my-data/develop/organisation-praise/',
  //   },
  //   {
  //     key: FEEDBACK_INTENTS.FEEDBACK_PENDING_ON_ME,
  //     label: 'Pending on me',
  //     path: '/app/my-data/develop/feedback/?feedbackView=PENDING',
  //   },
  //   {
  //     key: FEEDBACK_INTENTS.FEEDBACK_RECEIVED_BY_ME,
  //     label: 'Received by me',
  //     path: '/app/my-data/develop/feedback/?feedbackView=RECEIVED',
  //   },
  //   {
  //     key: FEEDBACK_INTENTS.FEEDBACK_SHARED_BY_ME,
  //     label: 'Shared by me',
  //     path: '/app/my-data/develop/feedback/?feedbackView=SHARED',
  //   },
  //   {
  //     key: FEEDBACK_INTENTS.FEEDBACK_REQUESTS_FROM_ME,
  //     label: 'Requests from me',
  //     path: '/app/my-data/develop/feedback/?feedbackView=REQUESTED',
  //   },
  // ],

  oneOnOne: [
    {
      key: ONE_ON_ONE_INTENTS.ONE_ON_ONE_LIST,
      label: 'My 1:1s',
      path: '/app/my-data/oneOnOne/my-one-on-one/?oneOnOneType=ACTIVE',
      isMobileSupport: true,
    },
    {
      key: ONE_ON_ONE_INTENTS.ARCHIVED_ONE_ON_ONE,
      label: 'Archived 1:1s',
      path: '/app/my-data/oneOnOne/my-one-on-one/?oneOnOneType=ARCHIVED',
      isMobileSupport: true,
    },
  ],

  review: [
    {
      key: REVIEW_INTENTS.PENDING_ON_ME,
      label: 'Pending on me',
      path: '/app/my-data/review/my-reviews/?activeTableId=PENDING_ON_ME',
      isMobileSupport: true,
    },
    {
      key: REVIEW_INTENTS.PENDING_ON_OTHERS,
      label: 'Pending on others',
      path: '/app/my-data/review/my-reviews/?activeTableId=PENDING_ON_OTHERS',
      isMobileSupport: true,
    },
    {
      key: REVIEW_INTENTS.COMPLETED_BY_ME,
      label: 'Completed by me',
      path: '/app/my-data/review/my-reviews/?activeTableId=COMPLETED_BY_ME',
      isMobileSupport: true,
    },
    {
      key: REVIEW_INTENTS.MY_PAST_REVIEWS,
      label: 'Past reviews',
      path: '/app/my-data/review/my-reviews/?activeTableId=MY_PAST_REVIEWS',
      isMobileSupport: true,
    },
  ],

  disciplinaryActions: [
    {
      key: DISCIPLINARY_ACTIONS_INTENT_ID_MAP.PENDING,
      label: 'Pending actions',
      path: '/app/my-data/disciplinaryActions/pending-disciplinary-actions/',
      isMobileSupport: true,
    },
    {
      key: DISCIPLINARY_ACTIONS_INTENT_ID_MAP.ALL,
      label: 'All disciplinary notes',
      path: '/app/my-data/disciplinaryActions/all-disciplinary-actions/',
      isMobileSupport: true,
    },
  ],

  engagement: [
    {
      key: ENGAGEMENT_INTENTS.ENGAGEMENT_PENDING_ON_ME,
      label: 'Pending on me',
      path: '/app/my-data/engagement/my-surveys/?surveyType=ACTIVE_SURVEYS',
      isMobileSupport: true,
    },
    {
      key: ENGAGEMENT_INTENTS.ENGAGEMENT_COMPLETED_SURVEYS,
      label: 'Completed surveys',
      path: '/app/my-data/engagement/my-surveys/?surveyType=SUBMITTED_SURVEYS',
      isMobileSupport: false,
    },
  ],

  // initiative: [
  //   {
  //     key: INITIATIVE_INTENTS.MY_INITIATIVES,
  //     label: 'My initiatives',
  //     path: '/app/my-data/initiative/my-initiatives/',
  //   },
  // ],

  points: [
    {
      key: POINTS_INTENTS.MY_POINTS,
      label: 'My points',
      path: L3_PATHS['my-data'].points.myPoints,
      isMobileSupport: true,
    },
  ],

  rewards: [
    {
      key: 'my-rewards-dashboard',
      label: 'Dashboard',
      path: L3_PATHS['my-data'].rewards.dashboard,
      isMobileSupport: true,
    },
    {
      key: 'my-rewards-leaderboard',
      label: 'Leaderboard',
      path: L3_PATHS['my-data'].rewards.leaderboard,
      isMobileSupport: true,
    },
  ],
};

export const NETCHEX_MOBILE_SUPPORTED_PATHS = [
  L3_PATHS['my-data'].goal.myGoals,
  L3_PATHS['my-data'].disciplinaryActions.allDisciplinaryActions,
  L3_PATHS['my-data'].disciplinaryActions.pendingDisciplinaryActions,
  L3_PATHS['my-data'].oneOnOne.instancePage,
  L3_PATHS['my-data'].oneOnOne.myOneOnOne,
  L3_PATHS['my-data'].points.myPoints,
  // query param is used here because different intents have same path but different query params
  // not required as of now for other such paths such as in reviews,
  // because all variation of same path and different query param supports mobile page
  L3_PATHS['my-data'].engagement.mySurveys,
  // survey filling page
  L3_PATHS['my-data'].engagement.activeSurvey,
  L3_PATHS.team.allReports.goal.manage,
  L3_PATHS.team.allReports.disciplinaryActions.pendingDisciplinaryActions,
  L3_PATHS.team.allReports.disciplinaryActions.allDisciplinaryActions,
  L3_PATHS.team.allReports.oneOnOne.manage,
  L3_PATHS.team.allReports.oneOnOne.instancePage,
  L3_PATHS['my-data'].review.myReviews,
  staticRoutesWithCustomSidebar.reviewsFormFilling,
  staticRoutesWithCustomSidebar.reviewsResultPage,
  L3_PATHS.team.allReports.review.calibratedResults,
  L3_PATHS.team.allReports.review.completionStatus,
  L3_PATHS.company.compensation.planning,
  L3_PATHS.team.allReports.points.points,
  L3_PATHS.team.directReports.points.points,
];
